import { RouteNames } from "@/router/routes.ts";
import { defineStore } from "pinia";
import { computed } from "vue";
import { useRouter } from "vue-router";

export const useLayoutStore = defineStore("layout", () => {

    const router = useRouter();

    const hideHeader = computed(() => {
        return router.currentRoute.value.name === RouteNames.LOGIN;
    });

    const hideFooter = computed(() => {
        return router.currentRoute.value.name === RouteNames.LOGIN;
    });

    return {
        hideHeader,
        hideFooter
    };
});